import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './Press.css';

const PressNew = () => {
  const [expandedBrand, setExpandedBrand] = useState('eco-warriors');
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [lightboxImage, setLightboxImage] = useState(null);

  // Organized press coverage by brand
  const pressByBrand = {
    'eco-warriors': {
      name: 'Eco-Warriors™',
      color: '#00B7C2',
      articles: [
        { date: '2019-04-02', year: '2019', publication: 'Ict.io', headline: '1st announcement at Gamecon 2019', excerpt: 'Initial announcement of Eco-Warriors at Gamecon 2019.', link: 'https://ict.io/gamecon-2019-une-grande-premiere-a-lile-maurice/', type: 'local', image: null, thumbnail: null },
        { date: '2019-06-30', year: '2019', publication: 'L\'Hebdo Dimanche', headline: 'Brian and Veda Dean - In the shoes of panda and wolf', excerpt: 'Eco Warriors is the first educational game in the Indian Ocean and sub-Saharan Africa.', link: 'https://defimedia.info/brian-et-veda-dean-dans-la-peau-du-panda-et-du-loup', type: 'local', image: null, thumbnail: null },
        { date: '2019-07-04', year: '2019', publication: 'Ict.io', headline: 'Eco-Warriors, the eco-conscious game 100% Made in Moris', excerpt: 'Launch announcement of eco-conscious Made in Mauritius game.', link: 'https://ict.io/eco-warriors-jeu-eco-conscious/', type: 'local', image: null, thumbnail: null },
        { date: '2019-09-06', year: '2019', publication: 'Southern Africa Startup Awards', headline: 'BEST SOCIAL IMPACT STARTUP', excerpt: 'Eco-Warriors nominated as BEST SOCIAL IMPACT STARTUP.', link: 'https://public-voting.globalstartupawards.com/competition-public-voting/5cd57094fc02923906725713?nominationId=5d2897225b4875196bbb4884', type: 'international', image: null, thumbnail: null },
        { date: '2019-10-18', year: '2019', publication: 'Venture Burn (South Africa)', headline: 'Eco-Warriors wins at Seedstars Port Louis', excerpt: 'Coverage of Eco Warriors success at Seedstars Summit Africa.', link: 'https://ventureburn.com/2019/10/eco-warriors-seedstars-port-louis/', type: 'international', image: null, thumbnail: null },
        { date: '2019-10-19', year: '2019', publication: 'Disrupt Africa', headline: 'Edu-tainment startup named winner of Seedstars event', excerpt: 'Named SSW BEST STARTUP to represent Port Louis at Seedstars Summit Africa.', link: 'https://disrupt-africa.com/2019/10/edu-tainment-startup-named-winner-of-seedstars-event-in-mauritius/', type: 'international', image: null, thumbnail: null },
        { date: '2019-12-26', year: '2019', publication: 'SABC News (South Africa)', headline: 'Six African start-ups doing business for good in 2019', excerpt: 'Featured among six African startups making positive impact.', link: 'http://www.sabcnews.com/sabcnews/from-medicine-to-recycling-six-african-start-ups-doing-business-for-good-in-2019/', type: 'international', image: null, thumbnail: null },
        { date: '2019-12-26', year: '2019', publication: 'Business Day (South Africa)', headline: 'Six African start-ups doing business for good', excerpt: 'Recognition for innovative solutions to African problems.', link: 'https://www.businesslive.co.za/bd/companies/2019-12-26-six-african-start-ups-doing-business-for-good-in-2019/', type: 'international', image: null, thumbnail: null },
        { date: '2019-12-26', year: '2019', publication: 'MoneyWeb (South Africa)', headline: 'Teaching sustainability through gaming', excerpt: 'Mobile game teaching children about climate change and conservation with UNESCO support.', link: 'https://www.moneyweb.co.za/news/africa/from-medicine-to-recycling-6-african-start-ups-doing-business-for-good-in-2019/', type: 'international', image: null, thumbnail: null },
        { date: '2020-01-02', year: '2020', publication: 'Sowetan Live', headline: 'Six African start-ups doing business for good', excerpt: 'Thomson Reuters Foundation coverage of impactful African startups.', link: 'https://www.sowetanlive.co.za/business/2020-01-02-from-medicine-to-recycling-6-african-start-ups-doing-business-for-goo/d/', type: 'international', image: null, thumbnail: null },
        { date: '2020-01-13', year: '2020', publication: 'Disrupt Africa', headline: 'Mauritian startup aims to encourage recycling', excerpt: 'UNESCO-backed eco-game promoting recycling awareness.', link: 'https://disrupt-africa.com/2020/01/mauritian-startup-aims-to-encourage-recycling-with-unesco-backed-eco-game/', type: 'international', image: null, thumbnail: null },
      ]
    },
    'discover-mauritius': {
      name: 'Discover Mauritius™',
      color: '#a855f7',
      articles: [
        { date: '2019-06-30', year: '2019', publication: 'L\'Hebdo Dimanche', headline: 'Discover Mauritius - Celebrating Local Talent', excerpt: 'Discover Mauritius Talents Night 2019. App has 200,000 visits monthly and 50,000+ users.', link: 'https://defimedia.info/brian-et-veda-dean-dans-la-peau-du-panda-et-du-loup', type: 'local', image: null },
      ]
    },
    'panda-wolf': {
      name: 'The Prisma Global',
      color: '#d4a574',
      articles: [
        { date: '2019-06-30', year: '2019', publication: 'L\'Hebdo Dimanche', headline: 'Panda & Wolf Holding - From Advertising to Global Ventures', excerpt: 'Evolution from advertising agency to global holding company.', link: 'https://defimedia.info/brian-et-veda-dean-dans-la-peau-du-panda-et-du-loup', type: 'local', image: null, thumbnail: null, isImageArticle: false },
        { date: '2020-01-20', year: '2020', publication: 'Essentielle Magazine', headline: 'Cover Feature - Women in Tech & Entrepreneurship', excerpt: 'Essentielle Magazine cover feature highlighting Vedavati\'s journey in technology and entrepreneurship in Mauritius.', link: null, type: 'local', image: '/press-essentielle-cover.jpeg', thumbnail: '/press-essentielle-cover.jpeg', isImageArticle: true },
        { date: '2020-01-20', year: '2020', publication: 'Essentielle Magazine', headline: 'Interview Feature - The Journey of Innovation', excerpt: 'In-depth interview discussing the entrepreneurial journey, challenges, and vision for building impactful ventures in Africa.', link: null, type: 'local', image: '/press-essentielle-english.png', thumbnail: '/press-essentielle-english.png', isImageArticle: true },
        { date: '2020-02-14', year: '2020', publication: 'Defi Business', headline: 'Female Role Model of the Year Award', excerpt: 'Recognition as Female Role Model of the Year for innovation in technology and social impact entrepreneurship.', link: null, type: 'local', image: '/press-defi-role-model.jpeg', thumbnail: '/press-defi-role-model.jpeg', isImageArticle: true },
        { date: '2018-09-17', year: '2018', publication: 'Le Défi Quotidien', headline: 'J\'ai abandonné des études en médecine pour la créativité', excerpt: 'Veda Dean\'s entrepreneurial journey from medicine to creative technology and innovation in Mauritius.', link: null, type: 'local', image: '/press-defi-first-interview.jpg', thumbnail: '/press-defi-first-interview.jpg', isImageArticle: true },
        { date: '2020-05-17', year: '2020', publication: 'The New Indian Express', headline: 'Straightening the Curve - Women Entrepreneurs Making Strides', excerpt: 'Feature on Veda Lolge as Earth Mother and Word Weaver, empowering kids through Eco-Warriors and creative writing.', link: null, type: 'international', image: '/press-indian-express.jpg', thumbnail: '/press-indian-express.jpg', isImageArticle: true },
        { date: '2020-07-19', year: '2020', publication: '5-Plus', headline: 'Des femmes entrepreneurs mauriciennes rayonnent en Afrique australe', excerpt: 'Coverage of Mauritian women entrepreneurs shining in Southern Africa, featuring Veda Dean\'s ventures.', link: null, type: 'international', image: '/press-wia-finalist.jpg', thumbnail: '/press-wia-finalist.jpg', isImageArticle: true },
        { date: '2019-01-01', year: '2019', publication: 'Careers Platform', headline: 'Co-Founder & Chief Operating Officer - Role Model Feature', excerpt: 'Featured as Careers 1825 Role Model highlighting female leadership, innovation and entrepreneurship in Africa.', link: null, type: 'international', image: '/press-careers-platform.png', thumbnail: '/press-careers-platform.png', isImageArticle: true },
        { date: '2018-12-06', year: '2018', publication: 'Pune Mirror', headline: 'Clicking with the Code - Pune Foreign Students Community', excerpt: 'Coverage of Pune Foreign Students meetup and the fast-growing Facebook group fostering cultural exchange.', link: null, type: 'local', image: '/press-pune-mirror.jpg', thumbnail: '/press-pune-mirror.jpg', isImageArticle: true },
        { date: '2019-12-09', year: '2019', publication: 'Divya Marathi', headline: 'Eco-Warriors Game School Curriculum - Solapur Youth Veda\'s Innovation', excerpt: 'First African experiment in Mauritius, Solapur youth Veda\'s idea: Eco-Warriors game school curriculum launched with UNESCO support and environmental awareness promotion.', link: null, type: 'local', image: '/press-divya-marathi.jpeg', thumbnail: '/press-divya-marathi.jpeg', isImageArticle: true },
        { date: '2020-01-15', year: '2020', publication: 'Lokmat News', headline: 'Solapur Youth Creating Waves with Environmental Gaming Innovation', excerpt: 'Statewide coverage of Eco-Warriors success and its impact on environmental education across Maharashtra and Africa.', link: null, type: 'local', image: '/press-lokmat-statewide.jpeg', thumbnail: '/press-lokmat-statewide.jpeg', isImageArticle: true },
        { date: '2019-12-15', year: '2019', publication: 'Sakal Times', headline: 'Innovation in Environmental Education - Eco-Warriors Game Launch', excerpt: 'Sakal Times coverage of Eco-Warriors launch, highlighting the innovative approach to environmental education through gaming and UNESCO partnership.', link: null, type: 'local', image: '/press-sakal-times.jpeg', thumbnail: '/press-sakal-times.jpeg', isImageArticle: true },
      ]
    },
    'elections-2024': {
      name: 'Election Campaign 2024',
      color: '#ec4899',
      articles: []
    }
  };

  const toggleBrand = (brand) => {
    setExpandedBrand(expandedBrand === brand ? null : brand);
  };

  // Get all images for the card stack
  const allPressImages = [];
  Object.entries(pressByBrand).forEach(([brandKey, brandData]) => {
    brandData.articles
      .filter(article => article.image)
      .forEach(article => {
        allPressImages.push({
          ...article,
          brandName: brandData.name,
          brandColor: brandData.color
        });
      });
  });

  const nextCard = () => {
    setCurrentCardIndex((prev) => (prev + 1) % allPressImages.length);
  };

  const prevCard = () => {
    setCurrentCardIndex((prev) => (prev - 1 + allPressImages.length) % allPressImages.length);
  };

  const openLightbox = (image) => {
    setLightboxImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="press-page">
      <SEO 
        title="Press & Media | The Prisma Global - Solapur's Fashion Revolution Featured Globally"
        description="Media coverage of The Prisma Global's journey transforming Solapur into India's ethical fashion capital. Featured in international press, UNESCO patronage, award-winning sustainable textile manufacturing. Campaign management for Maharashtra elections."
        keywords="Prisma Global press, Solapur textile media coverage, sustainable fashion India news, UNESCO patronage, Veda Lolge media, ethical fashion entrepreneur press, Maharashtra women entrepreneur, Solapur fashion industry news, impact entrepreneurship media"
        canonical="/press"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Press & Media Coverage - The Prisma Global",
          "description": "International and national media coverage of The Prisma Global's impact in sustainable fashion and women empowerment"
        }}
      />
      {/* Header */}
      <Navbar />

      {/* Hero */}
      <section className="press-hero">
        <div className="press-hero-content">
          <div className="hero-label">
            <span>MEDIA</span>
            <span className="separator">—</span>
            <span>COVERAGE</span>
          </div>
          
          <h1 className="press-hero-title-fixed">
            <span className="title-line-press">PRESS</span>
            <span className="title-line-press large">&amp; MEDIA</span>
          </h1>
          
          <p className="press-hero-subtitle">
            Documenting THE PRISMA GLOBAL's Journey of Innovation & Impact
          </p>
        </div>
      </section>

      {/* Election Campaign Gallery */}
      <section className="election-gallery-section">
        <div className="section-container">
          <h2 className="gallery-title">2024 MAHARASHTRA VIDHAN SABHA ELECTIONS</h2>
          <p className="gallery-subtitle">Election Management Campaign • Team Prisma Global</p>
          
          <div className="election-header-card">
            <div className="election-badge">WINNING CAMPAIGN</div>
            <h3>Hon. Radhakrishna Vikhe Patil</h3>
            <p className="election-role">Revenue Minister, Government of Maharashtra</p>
            <p className="election-result">Winner - Ahilyanagar Constituency</p>
            <p className="election-services">Services: Campaign Strategy, Team Management, Social Media Management, Ground Operations</p>
          </div>

          <div className="election-photos-grid">
            <div className="election-photo-item" onClick={() => openLightbox({ image: '/election-team-recruitment.jpg', brandName: 'Elections 2024', brandColor: '#ec4899', publication: 'Social Media Team Recruitment', date: '2024-11-01', headline: 'Social Media Team recruitment with Hon. Radhakrishna Vikhe Patil Saheb' })}>
              <img src="/election-team-recruitment.jpg" alt="Team Recruitment" />
              <div className="election-caption">Social Media Team Recruitment</div>
            </div>
            <div className="election-photo-item" onClick={() => openLightbox({ image: '/election-pravara-meeting.jpg', brandName: 'Elections 2024', brandColor: '#ec4899', publication: 'Pravara Institute Meeting', date: '2024-10-15', headline: 'Meeting with stakeholders at Pravara Institute, Loni' })}>
              <img src="/election-pravara-meeting.jpg" alt="Pravara Meeting" />
              <div className="election-caption">Stakeholder Meeting - Pravara Institute</div>
            </div>
            <div className="election-photo-item" onClick={() => openLightbox({ image: '/election-reel-workshop.jpg', brandName: 'Elections 2024', brandColor: '#ec4899', publication: 'Reel Making Workshop', date: '2024-10-20', headline: 'Reel Making Workshop by Ms. Veda Lolge for Pravara Students' })}>
              <img src="/election-reel-workshop.jpg" alt="Workshop" />
              <div className="election-caption">Reel Making Workshop by Ms. Veda Lolge</div>
            </div>
            <div className="election-photo-item" onClick={() => openLightbox({ image: '/election-mantralaya-meeting.jpg', brandName: 'Elections 2024', brandColor: '#ec4899', publication: 'Mantralaya Meeting', date: '2024-09-10', headline: 'Meeting at Mantralaya, Mumbai for Election Team Management' })}>
              <img src="/election-mantralaya-meeting.jpg" alt="Mantralaya" />
              <div className="election-caption">Team Management Meeting - Mantralaya, Mumbai</div>
            </div>
            <div className="election-photo-item" onClick={() => openLightbox({ image: '/election-diwali-planning.jpg', brandName: 'Elections 2024', brandColor: '#ec4899', publication: 'Campaign Activities Planning', date: '2024-10-25', headline: 'Discussions with Ms. Susmita Vikhe Patil for Campaign Activities' })}>
              <img src="/election-diwali-planning.jpg" alt="Campaign Planning" />
              <div className="election-caption">Campaign Activities Planning with Ms. Susmita Vikhe Patil</div>
            </div>
          </div>
        </div>
      </section>

      {/* Press Articles Section */}
      <section className="press-articles-section">
        <div className="section-container">
          <h2 className="gallery-title">PRESS COVERAGE</h2>
          <p className="gallery-subtitle">Media features and publications</p>
          
          <div className="press-articles-grid">
            {Object.entries(pressByBrand)
              .filter(([key]) => key !== 'elections-2024')
              .flatMap(([brandKey, brandData]) => 
                brandData.articles
                  .filter(article => article.link || article.isImageArticle)
                  .map((article) => ({ article, brandKey, brandData }))
              )
              .sort((a, b) => {
                // Image articles first, then text articles
                if (a.article.isImageArticle && !b.article.isImageArticle) return -1;
                if (!a.article.isImageArticle && b.article.isImageArticle) return 1;
                return 0;
              })
              .map(({ article, brandKey, brandData }, idx) => {
                    // For image articles, open lightbox. For link articles, open link.
                    if (article.isImageArticle) {
                      return (
                        <div 
                          key={`${brandKey}-${idx}`}
                          onClick={() => openLightbox({
                            image: article.image,
                            brandName: brandData.name,
                            brandColor: brandData.color,
                            publication: article.publication,
                            date: article.date,
                            headline: article.headline
                          })}
                          className="press-article-card press-article-card-clickable"
                          style={{ borderLeftColor: brandData.color }}
                        >
                          {article.thumbnail && (
                            <div className="article-thumbnail">
                              <img src={article.thumbnail} alt={article.headline} />
                            </div>
                          )}
                          <div className="article-card-content">
                            <div className="article-meta">
                              <span className="article-brand" style={{ color: brandData.color }}>{brandData.name}</span>
                              <span className="article-date-badge">{new Date(article.date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}</span>
                            </div>
                            <h3 className="article-card-headline">{article.headline}</h3>
                            <p className="article-card-excerpt">{article.excerpt}</p>
                            <div className="article-footer">
                              <span className="article-publication">{article.publication}</span>
                              <span className="article-read-more">View Full Image →</span>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <a 
                          key={`${brandKey}-${idx}`}
                          href={article.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="press-article-card"
                          style={{ borderLeftColor: brandData.color }}
                        >
                          {article.thumbnail && (
                            <div className="article-thumbnail">
                              <img src={article.thumbnail} alt={article.headline} />
                            </div>
                          )}
                          <div className="article-card-content">
                            <div className="article-meta">
                              <span className="article-brand" style={{ color: brandData.color }}>{brandData.name}</span>
                              <span className="article-date-badge">{new Date(article.date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}</span>
                            </div>
                            <h3 className="article-card-headline">{article.headline}</h3>
                            <p className="article-card-excerpt">{article.excerpt}</p>
                            <div className="article-footer">
                              <span className="article-publication">{article.publication}</span>
                              <span className="article-read-more">Read Article →</span>
                            </div>
                          </div>
                        </a>
                      );
                    }
                  })}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={32} />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={lightboxImage.image} alt={lightboxImage.headline} className="lightbox-image" />
            <div className="lightbox-info">
              <span className="lightbox-brand" style={{ color: lightboxImage.brandColor }}>{lightboxImage.brandName}</span>
              <h3 className="lightbox-publication">{lightboxImage.publication}</h3>
              <p className="lightbox-date">{new Date(lightboxImage.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
            </div>
          </div>
        </div>
      )}

      {/* Media Contact - Compact */}
      <section className="media-contact-compact">
        <div className="section-container">
          <div className="media-contact-bar">
            <div className="media-contact-label">
              <strong>MEDIA INQUIRIES</strong>
            </div>
            <div className="media-contact-info">
              <span className="contact-email">
                <strong>Email:</strong> info@theprismaglobal.com
              </span>
              <span className="contact-divider">|</span>
              <span className="contact-phone">
                <strong>Phone:</strong> +91 9356 107 460
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PressNew;
